import useRouter from "@hooks/useRouter"

import { faIcon } from "@utils/faIcon"

import { IconButton, Tooltip } from "@atoms"

import { NavTopBarBackButtonProps } from "./NavTopBarBackButton.types"

export default function NavTopBarBackButton(props: NavTopBarBackButtonProps) {
    const { destination } = props

    const { push } = useRouter()

    const onClick = () => {
        push(destination)
    }

    return (
        <Tooltip body="Go back" wrapChildren={false}>
            <IconButton
                size="lg"
                variant="ghost"
                className="back-button"
                icon={faIcon({ name: "arrow-left", style: "regular" })}
                onClick={onClick}
                aria-label="Navigate back"
                noDebounce={true}
            />
        </Tooltip>
    )
}
